<div class="flex brands-rows flex-wrap">
    @for (client of clientsResource.value(); track $index) {
        <div class="logo">
            <img loading="lazy" [width]="200" height="200" [placeholder]="true" [disableOptimizedSrcset]="true" [ngSrc]="client.img.src" [alt]="client.name" />
        </div>
    }
</div>
